

























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import IQuestion from '@/models/IQuestion';
import IComment from '@/components/icons/IComment.vue';
import IPost from '@/components/icons/IPost.vue';
import {EventBus} from '@/event-bus';

@Component({
  name: "PostSignature",
  components: {IPost, IComment}
})
export default class PostSignature extends Vue {
  @Prop({type: Array, default: () => []}) item!: []
  @Prop({type: String, default: () => ''}) selectedQuestion!: ''
  post = []

  deletePost (id:any) {
    this.$emit('deleteQuestion',id)
  }

  @Watch('item')
  getPostSignature(val: any) {
    this.post = val.filter((ele: any) => {
      return ele.type === 'text_post'
    })
  }
  @Watch('item.type')
  getItemType(val: any) {
    this.post = this.item
  }
  mounted(){
    this.post = this.item.filter((ele: any) => {
      return ele.type === 'text_post'
    })
  }
  clickHandler (id:any) {
    EventBus.$emit('questionBoxClicked', id)
  }
}
